import './App.css';
import LandingPage from './unAuth/LandingPage';

function App() {
  return <LandingPage />;
}

export default App;
